import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addDietryReport } from "../api/dietary-report.api";
import { dietrydata } from "../schema/dietary-report.schema";
import { dietKeys } from "./useDietaryReports";
import { toast } from "react-toastify";
import axios from "axios";

export const useAddDietReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      data,
      customerId,
      memberId,
    }: {
      data: dietrydata;
      customerId: number;
      memberId: number;
    }) => addDietryReport(data, customerId, memberId),

    onSuccess: (_, { memberId }) => {
      queryClient.invalidateQueries({ queryKey: dietKeys.list(memberId) });

      toast.success("Diet Report Added!");
    },

    onError: (error) => {
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        toast.error(error?.response.data.message || "Something went wrong!");
      } else {
        toast.error("Failed to submit health report");
      }
    },
  });
};
